__turbopack_context__.v({
  "profile-photo": "profile-photo-module-scss-module__MjfYEa__profile-photo",
  "profile-photo--has-border": "profile-photo-module-scss-module__MjfYEa__profile-photo--has-border",
  "profile-photo--is-fluid": "profile-photo-module-scss-module__MjfYEa__profile-photo--is-fluid",
  "profile-photo--large": "profile-photo-module-scss-module__MjfYEa__profile-photo--large",
  "profile-photo--xsmall": "profile-photo-module-scss-module__MjfYEa__profile-photo--xsmall",
  "profile-photo__content": "profile-photo-module-scss-module__MjfYEa__profile-photo__content",
  "profile-photo__content--hover": "profile-photo-module-scss-module__MjfYEa__profile-photo__content--hover",
  "profile-photo__icon": "profile-photo-module-scss-module__MjfYEa__profile-photo__icon",
  "profile-photo__image": "profile-photo-module-scss-module__MjfYEa__profile-photo__image",
});
